import { NavMenu } from "@shopify/app-bridge-react";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import agent from "../api/agent";
import { useStore } from "../stores/store";
import {
    FITMENT_CATALOG_LABEL_CHANGED,
    getCachedFitmentCatalogLabel,
    getStoredFitmentCatalogLabel,
    setCachedFitmentCatalogLabel,
} from "../utils/fitmentCatalogLabel";
import { isProductGuideEnabledForCurrentContext } from "../utils/productGuideFeature";
import { isServiceBookingEnabledForShop } from "../utils/serviceBookingFeature";

const AppNavMenu = () => {
    const { userStore } = useStore();
    const [vehicleLabel, setVehicleLabel] = useState(() => getStoredFitmentCatalogLabel() ?? "");
    // Temporary rollout gate: Trail Ops staging can see the guide builder during development.
    const showProductGuides = isProductGuideEnabledForCurrentContext(userStore.user?.shopDomain);
    const showServiceBooking = isServiceBookingEnabledForShop(userStore.user?.shopDomain);

    useEffect(() => {
        let cancelled = false;

        const loadVehicleLabel = async () => {
            try {
                const catalog = await agent.Settings.fitmentCatalog();
                if (!cancelled) {
                    setVehicleLabel(setCachedFitmentCatalogLabel(catalog.name));
                }
            } catch {
                if (!cancelled) setVehicleLabel(getCachedFitmentCatalogLabel());
            }
        };

        const handleLabelChange = (event: Event) => {
            const nextLabel = (event as CustomEvent<string>).detail;
            if (nextLabel) setVehicleLabel(nextLabel);
        };

        window.addEventListener(FITMENT_CATALOG_LABEL_CHANGED, handleLabelChange);
        loadVehicleLabel();
        return () => {
            cancelled = true;
            window.removeEventListener(FITMENT_CATALOG_LABEL_CHANGED, handleLabelChange);
        };
    }, []);

    return (
        <NavMenu>
            <a href="/dashboard" rel="home">
                Dashboard
            </a>
            <a href="/setup-health">Setup &amp; Health</a>
            <a href="/products">Products</a>
            <a href="/vehicles">{vehicleLabel || "\u00a0"}</a>
            {showProductGuides && <a href="/product-guides">Product Guides</a>}
            {showServiceBooking && <a href="/service-booking">Service Booking</a>}
            <a href="/imports">Imports</a>
            <a href="/reports">Reports</a>
            <a href="/storefront">Settings</a>
        </NavMenu>
    );
};

export default observer(AppNavMenu);
